<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" format="MM-DD-YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row" v-if="site_type == 'ho'">
                        <div class="col-md-4">
                            <base-input label="Location">
                                <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showAdvancedInfoDiv' >
                                {{showAdvancedInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Customer" >
                                <a-select v-model="inputCustomer" showSearch placeholder="[All Customer]" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="fetchCustomers">
                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                    <a-select-option v-for="option in customerOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isNetReturn">
                        Net of Return Sales
                    </base-checkbox>

                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{toggleLabel}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.toString().replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.toString().replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'

    var component_x;

    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'product_id',
                sortOptions: [
                    {key: 'product_id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'net_amount', value: 'Total Amount'},
                    {key: 'total_cost', value: 'Total Cost'},
                    {key: 'profit', value: 'Profit'},
                    {key: 'profit_percent', value: 'Profit %'}
                ],

                inputLocation: [],
                locationOptions: [],
                isSeparateSite: false,

                currDate: moment().format("L_LT").split(":"),
                isNetReturn: false,
                birSalesReports: [],
                fetching: false,
                inputCustomer: '',
                customerOptions: [],
                showAdvancedInfo: 'asc',
                JsonData: [],
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
                inputBrand: null,
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            this.customerOptions.push({
                id: '', name: ' [All Customer]', code: ''
            })
            component_x.getBrandOptions();
        },
        computed: {
            ...mapState(['currentProfile' ,'endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showAdvancedInfoDiv(){
                this.showAdvancedInfo == 'asc' ? this.showAdvancedInfo = 'desc' : this.showAdvancedInfo = 'asc'
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            async fetchCustomers(value){
                this.fetching = true
                let customers = await HTTPRequest.getRequest(this.endPoint + "customers/get_valid_customers?name=" + value , null)
                this.customerOptions = customers;
                this.customerOptions.push({
                    id: '', name: ' [All Customer]', code: ''
                })
                this.sort(this.customerOptions);
                this.fetching = false
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "isNetReturn": this.isNetReturn,
                    "order": this.inputSortBy,
                    "by": this.showAdvancedInfo,
                    "customer": this.inputCustomer,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'item_sales_profit?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    let header_top = [];
                    header_top.push(
                        {content: 'Quantity', styles: {halign: 'center'}},
                        {content: 'Unit', styles: {halign: 'center'}},
                        {content: 'Packing', styles: {halign: 'center'}},
                        {content: 'Product Code', styles: {halign: 'center'}},
                        {content: 'Barcode', styles: {halign: 'center'}},
                        {content: 'Stock No.', styles: {halign: 'center'}},
                        {content: 'Description', styles: {halign: 'center'}},
                        {content: 'Unit Price', styles: {halign: 'center'}},
                        {content: 'Cost', styles: {halign: 'center'}},
                        {content: 'Ave Price', styles: {halign: 'center'}},
                        {content: 'Gross Amt', styles: {halign: 'center'}},
                        {content: 'Discount', styles: {halign: 'center'}},
                        {content: 'Net Amt', styles: {halign: 'center'}},
                        {content: 'Total Cost', styles: {halign: 'center'}},
                        {content: 'Profit', styles: {halign: 'center'}}
                    )

                    headers = [header_top]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }
                        let reportData = [];

                        let grand_qty = 0
                        let grand_gross_amount = 0
                        let grand_discount = 0
                        let grand_net_amount = 0
                        let grand_total_cost = 0
                        let grand_profit = 0

                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let detail = [
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    reportLine.unit_code,
                                    this.convertToCurrency(Number(reportLine.content_quantity)),
                                    reportLine.product_id,
                                    reportLine.barcode,
                                    reportLine.stock_no,
                                    reportLine.name,
                                    this.convertToCurrency(Number(reportLine.retail_price)),
                                    this.convertToCurrency(Number(reportLine.landed_cost)),
                                    this.convertToCurrency(Number(reportLine.average_price)),
                                    this.convertToCurrency(Number(reportLine.gross_amount)),
                                    this.convertToCurrency(Number(reportLine.discount)),
                                    this.convertToCurrency(Number(reportLine.net_amount)),
                                    this.convertToCurrency(Number(reportLine.total_cost)),
                                    this.convertToCurrency(Number(reportLine.profit))
                                ]

                                grand_qty += Number(reportLine.qty)
                                grand_gross_amount += Number(reportLine.gross_amount)
                                grand_discount += Number(reportLine.discount)
                                grand_net_amount += Number(reportLine.net_amount)
                                grand_total_cost += Number(reportLine.total_cost)
                                grand_profit += Number(reportLine.profit)

                                reportData.push(Object.assign({}, detail))
                            }
                        }

                        if(x == siteSpecific.length - 1){
                            //Grand Total
                            reportData.push(Object.assign({}, ["rowLine"]))

                            let grand_detail = [
                                this.convertToCurrency(grand_qty),
                                '', '', '', '', '', '', 'Grand Total :', '', '',
                                this.convertToCurrency(grand_gross_amount),
                                this.convertToCurrency(grand_discount),
                                this.convertToCurrency(grand_net_amount),
                                this.convertToCurrency(grand_total_cost),
                                this.convertToCurrency(grand_profit),
                            ]
                            reportData.push(Object.assign({}, grand_detail));
                        }

                        let design_x = 490
                        let design_y = 330

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Item Sales Profit")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        doc.text(design_x,20,site_text,"right");
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: {
                                0: {cellWidth: 30},
                                1: {cellWidth: 20},
                                2: {cellWidth: 25},
                                3: {cellWidth: 30},
                                4: {cellWidth: 30},
                                5: {cellWidth: 30},
                                6: {cellWidth: 85},
                                7: {cellWidth: 25},
                                8: {cellWidth: 25},
                                9: {cellWidth: 25},
                                10: {cellWidth: 30},
                                11: {cellWidth: 25},
                                12: {cellWidth: 30},
                                13: {cellWidth: 30},
                                14: {cellWidth: 30}
                            },
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[7] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Item Sales Profit", design_x, design_y, i, pageCount)
                            // reportUtils.pdfTools.addFooter(doc, printed_by, "Item Sales Profit" + group_text, 525, 225, i, pageCount)
                        }
                        
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Item_Sales_Profit_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "isNetReturn": this.isNetReturn,
                    "order": this.inputSortBy,
                    "by": this.showAdvancedInfo,
                    "customer": this.inputCustomer,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'item_sales_profit?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_top = ['Quantity','Unit','Packing','Product Code','Barcode','Stock No','Description','Unit Price','Cost','Ave Price','Gross Amt','Discount','Net Amt','Total Cost','Profit']
                    headers = header_top
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        let reportData = [];

                        let grand_qty = 0
                        let grand_gross_amount = 0
                        let grand_discount = 0
                        let grand_net_amount = 0
                        let grand_total_cost = 0
                        let grand_profit = 0

                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let detail = [
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    reportLine.unit_code,
                                    this.convertToCurrency(Number(reportLine.content_quantity)),
                                    reportLine.product_id,
                                    reportLine.barcode,
                                    reportLine.stock_no,
                                    reportLine.name,
                                    this.convertToCurrency(Number(reportLine.retail_price)),
                                    this.convertToCurrency(Number(reportLine.landed_cost)),
                                    this.convertToCurrency(Number(reportLine.average_price)),
                                    this.convertToCurrency(Number(reportLine.gross_amount)),
                                    this.convertToCurrency(Number(reportLine.discount)),
                                    this.convertToCurrency(Number(reportLine.net_amount)),
                                    this.convertToCurrency(Number(reportLine.total_cost)),
                                    this.convertToCurrency(Number(reportLine.profit))
                                ]

                                grand_qty += Number(reportLine.qty)
                                grand_gross_amount += Number(reportLine.gross_amount)
                                grand_discount += Number(reportLine.discount)
                                grand_net_amount += Number(reportLine.net_amount)
                                grand_total_cost += Number(reportLine.total_cost)
                                grand_profit += Number(reportLine.profit)

                                reportData.push(Object.assign({}, detail))
                            }
                        }

                        if(x == siteSpecific.length - 1){
                            //Grand Total
                            // reportData.push(Object.assign({}, ["rowLine"]))

                            let grand_detail = [
                                this.convertToCurrency(grand_qty),
                                '', '', '', '', '', '', 'Grand Total :', '', '',
                                this.convertToCurrency(grand_gross_amount),
                                this.convertToCurrency(grand_discount),
                                this.convertToCurrency(grand_net_amount),
                                this.convertToCurrency(grand_total_cost),
                                this.convertToCurrency(grand_profit),
                            ]
                            reportData.push(Object.assign({}, grand_detail));
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push(["Item Sales Profit", "Generate By: " + printed_by,"Generate Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },

            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;
                
            },

            async getSubBrandData() {
                if (this.inputBrand != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_id=" +
                        this.inputBrand,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
